"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.md5 = void 0;
const tslib_1 = require("tslib");
const crypto_1 = tslib_1.__importDefault(require("crypto"));
const md5 = (data) => crypto_1.default
    .createHash('md5')
    .update(data)
    .digest('hex');
exports.md5 = md5;
